import axios from 'axios';
import BaseService from "./BaseService";

class AuthService extends BaseService {

  getUserId() {
    return localStorage.getItem('userId');
  }

  setUserId(userId) {
    localStorage.setItem('userId', userId);
  }

  setToken(token) {
    localStorage.setItem('token', token);
  }

  getToken() {
    return localStorage.getItem('token');
  }

  setTokenExpireTime(expire) {
    localStorage.setItem('tokenExpire', expire);
  }

  getTokenExpireTime() {
    return localStorage.getItem('tokenExpire');
  }

  async login(data, params) {
    try {
      let result = await axios.post('/login', data);
      let { token } = result.data;
      this.setToken(token);
      return result;
    } catch (e) {
      throw e;
    }
  }

  logout() {
    localStorage.clear();
    delete axios.defaults.headers.common['Authorization'];
  }


  forgotPassword(data) {
    return axios.post('/password', data);
  }

  async resetPassword(data) {
    return axios.post('/password/reset', data);
  }
}

export default new AuthService();
